var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .92L.92 0l3.54 3.54L8 0l.92.92-4.46 4.459L0 .919z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOSA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBpZD0iY2hldnJvbi1kb3duIiBkPSJNLTEuOTQ5MzZlLTA3IDAuOTE5Mjg3TDAuOTE5MjM5IDQuODEyMDRlLTA1TDQuNDU5NjIgMy41NDA0M0w4IDQuNzgxMDllLTA1TDguOTE5MjQgMC45MTkyODdMNC40NTk2MiA1LjM3ODkxTC0xLjk0OTM2ZS0wNyAwLjkxOTI4N1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgArrowDown as ReactComponent };